import { useMemo } from 'react';
import { format as dateFnsFormat } from 'date-fns';

export default function DateColumn({ date, format = 'dd-MM-yyyy HH:mm' }) {
  const columnDate = useMemo(() => new Date(date), [date]);

  try {
    return <div role="note">{dateFnsFormat(columnDate, format)}</div>;
  } catch (error) {
    return <div role="note">&mdash;</div>;
  }
}
